<template>
    <div class="authz-wrap">
        <section class="af-panel">
            <header class="af-header">
                <span class="af-title title">Lista de Autorização</span>
            </header>
            <div class="af-body">
                <div v-show="userLogged.user.userName == 'UserTemp'">
                    <div>
                        <Button _key="btnCreate" title="Solicitar Autorização" classIcon="fas fa-plus-circle"
                            type="primary" size="small" :clicked="create" />
                    </div>
                    <br />
                </div>
                <AuthorizationTable />
            </div>
        </section>
        <Modal title="Solicitar Autorização" :width="550" :height="750" v-if="showModal('authorization')">
            <AuthorizationCreate />
        </Modal>
    </div>
</template>

<script>
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";

import AuthorizationCreate from './AuthorizationCreate.vue'
import AuthorizationTable from './AuthorizationTable.vue'

import { mapState, mapGetters, mapMutations } from "vuex";

export default {
    name: 'Authorization',
    components: { Button, Modal, AuthorizationCreate, AuthorizationTable },
    computed: {
        ...mapState("user", ["userLogged"]),
        ...mapGetters("generic", ["showModal"]),
    },
    methods: {
        ...mapMutations("generic", ["openModal", "removeLoading"]),
        create() {
            this.openModal("authorization");
            this.removeLoading(["btnCreate"]);
        }
    }
}
</script>

<style scoped>
.authz-wrap {
    --af-border: #e6e7eb;
    --af-muted: #6b7280;
    --af-primary: #0f172a;
    --af-accent: #577696;
    --af-pad: 12px;
    --af-radius: 14px;
}

.af-panel {
    background: #fff;
    border: 1px solid var(--af-border);
    border-radius: var(--af-radius);
    overflow: hidden;
}

.af-header {
    padding: var(--af-pad);
    border-bottom: 1px solid var(--af-border);
}

.af-title {
    font-size: 14px;
    color: var(--af-primary);
    font-weight: 600;
}

.af-body {
    padding: var(--af-pad);
}
</style>
